import { AxiosRestService } from './AxiosRestService';

const rest = new AxiosRestService();

export interface FulfillCustomerOrderRequest {
  autoPackage: boolean;
  packages: Array<{
    weightOz: number;
    carrierCode?: string;
    serviceCode?: string;
    packageCode?: string;
    lengthIn?: number | null;
    widthIn?: number | null;
    heightIn?: number | null;
  }>;
}

export interface RefundLineItemRequest {
  lineItemId: string;
  quantity: number;
}

export interface RefundCustomerOrderRequest {
  reason?: string;
  lineRefunds?: RefundLineItemRequest[];
}

export interface RefundFullCustomerOrderRequest {
  reason?: string;
}

export class CustomerOrderService {
  getAll(): Promise<any> {
    return rest.get('customer-orders');
  }

  getPending(): Promise<any> {
    return rest.get('customer-orders/pending');
  }

  getById(orderId: string): Promise<any> {
    return rest.get(`customer-orders/${orderId}`);
  }

  getFulfillPrep(orderId: string): Promise<any> {
    return rest.get(`customer-orders/${orderId}/fulfill-prep`);
  }

  fulfill(orderId: string, body: FulfillCustomerOrderRequest): Promise<any> {
    return rest.post(`customer-orders/${orderId}/fulfill`, body);
  }

  markShipped(orderId: string): Promise<any> {
    return rest.post(`customer-orders/${orderId}/mark-shipped`, {});
  }

  refund(orderId: string, body: RefundCustomerOrderRequest): Promise<any> {
    return rest.post(`customer-orders/${orderId}/refund`, body);
  }

  refundFull(orderId: string, body: RefundFullCustomerOrderRequest): Promise<any> {
    return rest.post(`customer-orders/${orderId}/refund/full`, body);
  }

  updateNotes(orderId: string, notes: string): Promise<any> {
    return rest.put(`customer-orders/${orderId}/notes`, { notes });
  }

  updateShippingAddress(orderId: string, body: any): Promise<any> {
    return rest.put(`customer-orders/${orderId}/shipping-address`, body);
  }

  delete(orderId: string): Promise<any> {
    return rest.delete(`customer-orders/${orderId}`);
  }
}

export const customerOrderService = new CustomerOrderService();
